import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import { CompanyService } from '../../service/company.service'
import Popup from 'reactjs-popup';
import Alert from '../common/Alert';
import Confirmation from '../common/Confirmation';

import '../../../node_modules/reactjs-popup/dist/index.css';
import '../../../node_modules/ag-grid-community/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/styles/ag-theme-alpine.css';

const NewCompany = (params) => {
    const [company, setCompany] = useState({});
    const [applications, setApplications] = useState();
    const [authProviders, setAuthProviders] = useState([]);
    const [companyTypes, setCompanyTypes] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [parentCompany, setParentCompany] = useState([]);
    const [message, setMessage] = useState([]);
    const [isAlert, setIsAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');

    const [comParentCompany, setComParentCompany] = useState([]);
    const [comAuthProvider, setComAuthProvider] = useState([]);
    const [comCompanyType, setComCompanyType] = useState([]);
    const [comApplication, setComApplication] = useState([]);

    const [name, setName] = useState('');
    const [isSponsorRequired, setIsSponsorRequired] = useState(false);
    const [isSponsorDisabled, setIsSponsorDisabled] = useState(true);
    
    const [requestorName, setRequestorName] = useState('');
    const [requestorEmail, setRequestorEmail] = useState('');
    const [requestorDescription, setRequestorDescription] = useState('');
    const [allowedDomains, setAllowedDomains] = useState('');
    const [passwordExpiryDays, setPasswordExpiryDays] = useState('');
    const [reminderDays, setReminderDays] = useState('');
    const [isPasswordNeverExpires, setIsPasswordNeverExpires] = useState('');
    const [passwordComplexityRegEx, setPasswordComplexityRegEx] = useState('');
    const [passwordComplexityNote, setPasswordComplexityNote] = useState('');
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [gressPeriod, setGressPeriod] = useState('');
    const [passwordWarningIntervel, setPasswordWarningIntervel] = useState('');
    const [companyType, setCompanyType] = useState(0);
    const [companyTypeDisabled, setCompanyTypeDisabled] = useState(false);
    const [closeOnAlertClose, setCloseOnAlertClose] = useState(false);

    const companyService = new CompanyService();

    useEffect(() => {
        const fetchData = async () => {
            const result = await companyService.getcompanybyidtoedit(params.id ? params.id : 0);
            setCompany(result.data.company);
            setApplications(result.data.applications);
            setAuthProviders(result.data.authProviders);
            setCompanies(result.data.companies);
            setComApplication(result.data.companyApplication);
            if (result.data.company.id === 0) {
                setCompanyTypes(result.data.companyTypes);
                setCompanyTypeDisabled(false);
                hideandShowSponsorWorkflow(0);
            }
            else {
                setName(result.data.company.name);
                setAllowedDomains(result.data.company.allowedDomains);
                
                setIsPasswordNeverExpires(result.data.company.isPasswordNeverExpires);
                setPasswordExpiryDays(result.data.company.passwordExpiryDays);
                setReminderDays(result.data.company.reminderDays);
                setGressPeriod(result.data.company.gressPeriod);
                setPasswordWarningIntervel(result.data.company.passwordWarningIntervel);
                setPasswordComplexityRegEx(result.data.company.passwordComplexityRegEx);
                setPasswordComplexityNote(result.data.company.passwordComplexityNote);
                setRequestorName(result.data.company.requestorName);
                setRequestorEmail(result.data.company.requestorEmail);
                setRequestorDescription(result.data.company.requestorDescription);

                let compantTypevalue = result.data.company.companyTypeId ?
                    result.data.companyTypes.filter((x) => {
                        return (x.value === result.data.company.companyTypeId);
                    }) : result.data.companyTypes;
                setCompanyTypes(compantTypevalue);
                setCompanyTypeDisabled(true);
                
                let _parentCompanyValue = loadParentCompany(result.data.companies, result.data.company.companyTypeId);
                //setParentCompany(_parentCompanyValue);

                let comCompantTypevalue = result.data.company.companyTypeId ?
                    result.data.companyTypes.filter((x) => {
                        return (x.value === result.data.company.companyTypeId);
                    }) : {};
                setComCompanyType(comCompantTypevalue);

                const spValue = (comCompantTypevalue !== undefined && comCompantTypevalue.length > 0) ? comCompantTypevalue[0].value : 0;
                hideandShowSponsorWorkflow(spValue);

                let comAuthProviderValue = result.data.company.authenticationProviderId ?
                    result.data.authProviders.filter((x) => {
                        return (x.value === result.data.company.authenticationProviderId);
                    }) : {};
                setComAuthProvider(comAuthProviderValue);
                setIsReadOnly(comAuthProviderValue);

                
                setIsReadOnly(result.data.company.isReadOnly === 1 ? true : false);
                setIsSponsorRequired(result.data.company.isSponsorRequired === 1 ? true : false);

                if (_parentCompanyValue !== undefined) {
                    let comParentCompanyValue = _parentCompanyValue.filter((x) => {
                        return (x.value === result.data.company.ownerId);
                    });
                    setComParentCompany(comParentCompanyValue);
                }
            }
        }

        fetchData()
            .catch(console.error);
    }, []);

    const loadParentCompany = (list, id) => {
        let parentCompanyValue = list.filter((x) => {
            return (x.companyTypeId === (id === 2 ? 1 : (id === 4 ? 3 : 0)));
        }).map(function (a) {
            return { value: a.id, label: a.name };
        });
        setParentCompany(parentCompanyValue);
        return parentCompanyValue;
    };

    const setNewCompanyType = (e) => {
        setComCompanyType([e]);
        setCompanyType(e.value);
        removeMessage(7);
        loadParentCompany(companies, e.value);

        const cTypeValue = (e !== undefined) ? e.value : 0;
        hideandShowSponsorWorkflow(cTypeValue)
    };

    const hideandShowSponsorWorkflow = (val) => {
        if (val === 1 || val === 3) {
            setIsSponsorRequired(false);
            setIsSponsorDisabled(true);
        }
        else {
            setIsSponsorDisabled(false);
        }
    }

    const setNewAuthProviders = (e) => {
        setComAuthProvider([e]);
        setIsReadOnly(e.isValid);
        removeMessage(6);
    };

    const setNewParentCompany = (e) => {
        setComParentCompany([e]);
    };

    const setNewApplication = (e) => {
        setComApplication(e);
    };

    const setFormInput = (e, tag = undefined) => {
        if (e.target !== undefined) {
            tag = e.target.name;
        }

        if (tag === "name") {
            setName(e.target.value);
            removeMessage(1);
        }
        else if (tag === "isSponsorRequired") {
            setIsSponsorRequired(e.target.checked);
        }
        else if (tag === "isReadOnly") {
            setIsReadOnly(e.target.checked);
        }
        else if (tag === "allowedDomains") {
            setAllowedDomains(e.target.value);
        }
        else if (tag === "isPasswordNeverExpires") {
            setIsPasswordNeverExpires(e.target.checked);
        }
        else if (tag === "passwordExpiryDays") {
            setPasswordExpiryDays(e.target.value);
        }
        else if (tag === "gressPeriod") {
            setGressPeriod(e.target.value);
        }
        else if (tag === "passwordWarningIntervel") {
            setPasswordWarningIntervel(e.target.value);
        } else if (tag === "passwordComplexityRegEx") {
            setPasswordComplexityRegEx(e.target.value);
            removeMessage(2);
        } else if (tag === "passwordComplexityNote") {
            setPasswordComplexityNote(e.target.value);
            removeMessage(3);
        } else if (tag === "requestorName") {
            setRequestorName(e.target.value);
            removeMessage(4);
        } else if (tag === "requestorEmail") {
            setRequestorEmail(e.target.value);
            removeMessage(5);
        } else if (tag === "requestorDescription") {
            setRequestorDescription(e.target.value);
        } else if (tag === "reminderDays") {
            setReminderDays(e.target.value);
        }
    };

    const removeMessage = (id) => {
        if (message.length > 0) {
            let newMessage = message.filter((m) => {
                return (m.id !== id);
            });
            setMessage(newMessage);
        }
    };

    const checkValidation = () => {
        let result = true;
        let newMessage = [];

        let regex = new RegExp('[a-z0-9]+@[a-z0-9]+\.[a-z]{2,3}');


        if (!name || name.length === 0) {
            newMessage.push({ id: 1, text: "Company name is required" });
            result = false;
        }

        if (!passwordComplexityRegEx || passwordComplexityRegEx.length === 0) {
            newMessage.push({ id: 2, text: "Password Complexity RegEx is required" });
            result = false;
        }

        if (!passwordComplexityNote || passwordComplexityNote.length === 0) {
            newMessage.push({ id: 3, text: "Password Complexity Note is required" });
            result = false;
        }

        if (!requestorName || requestorName.length === 0) {
            newMessage.push({ id: 4, text: "Company requestor name is required" });
            result = false;
        }

        if (!requestorEmail || requestorEmail.length === 0) {
            newMessage.push({ id: 5, text: "Company requestor email is required" });
            result = false;
        }

        if (!regex.test(requestorEmail)) {
            newMessage.push({ id: 5, text: "Company requestor email is not valid" });
            result = false;
        }

        if (!comAuthProvider || comAuthProvider.length < 1) {
            newMessage.push({ id: 6, text: "Authentication provider is not valid" });
            result = false;
        }

        if (!comCompanyType || comAuthProvider.length < 1) {
            newMessage.push({ id: 7, text: "Company Type is not valid" });
            result = false;
        }

        setMessage(newMessage);
        return result;
    };

    const alertOff = () => {
        setIsAlert(false);

        if (closeOnAlertClose === true) {            
            if (params.callBack !== undefined) {
                params.callBack();
            }
            params.onClose();            
        }
    };

    const alertOn = () => {
        setIsAlert(true);
    };

    const onSuccess = async () => {
        if (checkValidation() === true) {
            console.log("I am going to save this company!");
            let companyModel = {
                id: (company.id ? company.id : 0),
                name: name,
                isActive: 1,
                companyTypeId: (comCompanyType && comCompanyType.length > 0) ? comCompanyType[0].value : 0,
                isSponsorRequired: (isSponsorRequired === '' ? 0 : (isSponsorRequired === true ? 1 : 0)),
                ownerId: (comParentCompany && comParentCompany.length > 0) ? comParentCompany[0].value : 0,
                requestorName: requestorName,
                requestorEmail: requestorEmail,
                requestorDescription: requestorDescription,
                sponsorName: "",
                sponsorEmail: "",
                allowedDomains: allowedDomains,
                passwordExpiryDays: (passwordExpiryDays === '' ? 0 : passwordExpiryDays),
                reminderDays: (reminderDays === '' ? 0 : reminderDays),
                isPasswordNeverExpires: (isPasswordNeverExpires === '' ? 0 : (isPasswordNeverExpires === true ? 1 : 0)),
                authenticationProviderId: (comAuthProvider && comAuthProvider.length > 0) ? comAuthProvider[0].value : 0,
                passwordComplexityRegEx: passwordComplexityRegEx,
                passwordComplexityNote: passwordComplexityNote,
                isReadOnly: (isReadOnly === '' ? 0 : (isReadOnly === true ? 1 : 0)),
                gressPeriod: (gressPeriod === '' ? 0 : gressPeriod),
                passwordWarningIntervel: (passwordWarningIntervel === '' ? 0 : passwordWarningIntervel),
                dateCreated: company.dateCreated ? company.dateCreated : new Date(),
                dateModified: company.dateModified ? company.dateModified : new Date(),
                status: "1",
                OrganizationalUnitPath: "umv2/" + name,
                companyApplications: comApplication
            }

            setCloseOnAlertClose(false);

            let saveResult = await companyService.updateCompany(companyModel);
            if (saveResult.status === 200) {
                if (saveResult.data && saveResult.data.isSuccess === false) {
                    setAlertMessage(saveResult.data.message);
                    alertOn(true);
                }
                else {
                    setCloseOnAlertClose(true);
                    setAlertMessage("Company data has been saved successfully");
                    alertOn(true);                                        
                }
            }
            else {
                setAlertMessage(saveResult.data.message);
                alertOn(true);
            }
        }
    }

    return (
        <>
            {isAlert && <div><Alert type="error" message={alertMessage} callBack={alertOff} /></div>}

            <div className="card" style={{ width: "975px", marginTop: "-5px", marginLeft: "-5px", marginBottom: "-5px", marginRight: "-5px" }}>
                <h5 className="card-header py-3">
                    <i className="fa fa-folder-open-o" aria-hidden="true"></i> Company
                </h5>
                <div className="card-body">
                    <div>
                        {(message.length > 0) ?
                            <ul>
                                {message.map(m =>
                                    <li style={{ color: "red" }} key={m.id}>{m.text}</li>
                                )}
                            </ul>
                            : ""}
                    </div>
                    <div className="ag-theme-alpine" style={{ height: "450px", marginRight: "-15px", overflowY: "auto" }}>
                        <div style={{ width: "915px" }}>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Name</label>
                                        <input type="text" className="form-control" id="name" name="name" onChange={e => setFormInput(e)} value={name} />

                                        <div className="p-2">
                                            <input id="isReadOnly" name="isReadOnly" type="checkbox" checked={isReadOnly} onChange={e => setFormInput(e)} />
                                            <label className="pl-2">Third party authentication</label>
                                        </div>
                                        <div className="p-2" style={{ marginTop: "-10px" }}>
                                            {(isSponsorDisabled === false) ?
                                                <>
                                                    <input id="isSponsorRequired" name="isSponsorRequired" type="checkbox" checked={isSponsorRequired} onChange={e => setFormInput(e)} />
                                                    <label className="pl-2">Sponsor Approval Required</label>
                                                </> : <></>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Authentication Provider</label>
                                        <Select options={authProviders} value={comAuthProvider} onChange={(e) => setNewAuthProviders(e)} />
                                    </div>
                                    <div className="form-group">
                                        <label>Company Type</label>
                                        <Select options={companyTypes} value={comCompanyType} onChange={(e) => setNewCompanyType(e)} isDisabled={companyTypeDisabled} />
                                    </div>
                                </div>
                            </div>


                            <div className="row" style={{ marginTop: "-10px" }}>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Application <span> (The first tool selected will be the primary tool for this company)</span></label>
                                        <Select options={applications} isMulti value={comApplication} onChange={(e) => setNewApplication(e)} />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Allowed Domains <span> (Please use comma to provide separate domain name)</span></label>
                                        <textarea name="textarea" cols="30" rows="3" className="form-control" id="allowedDomains" name="allowedDomains" onChange={e => setFormInput(e)} value={allowedDomains} ></textarea>
                                    </div>
                                </div>
                            </div>

                            <div className="row" style={{ marginTop: "-10px" }}>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Parent Company</label>
                                        <Select options={parentCompany} value={comParentCompany} readOnly={(companyType === 1 || companyType === 3)} onChange={(e) => setNewParentCompany(e)} />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="row" >
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Expires in</label>
                                                <input type="number" readOnly={isPasswordNeverExpires} className="form-control" id="passwordExpiryDays" name="passwordExpiryDays" placeholder="0" onChange={e => setFormInput(e)} value={passwordExpiryDays} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <label>Reminder day</label>
                                            <input type="number" readOnly={isPasswordNeverExpires} className="form-control" id="reminderDays" name="reminderDays" placeholder="0" onChange={e => setFormInput(e)} value={reminderDays} />
                                        </div>
                                        <div className="col-md-3">
                                            <label>Grace Period</label>
                                            <input type="number" readOnly={isPasswordNeverExpires} className="form-control" id="gressPeriod" name="gressPeriod" placeholder="0" onChange={e => setFormInput(e)} value={gressPeriod} />
                                        </div>
                                        <div className="col-md-3">
                                            <label>Intervel days</label>
                                            <input type="number" readOnly={isPasswordNeverExpires} className="form-control" id="passwordWarningIntervel" name="passwordWarningIntervel" placeholder="0" onChange={e => setFormInput(e)} value={passwordWarningIntervel} />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <input id="isPasswordNeverExpires" name="isPasswordNeverExpires" type="checkbox" onChange={e => setFormInput(e)} checked={isPasswordNeverExpires} />
                                            <label className="pl-2">Password never expires</label>
                                        </div>
                                    </div>

                                </div>
                            </div>


                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Password Complexity Regex</label>
                                        <input type="text" className="form-control" id="passwordComplexityRegEx" name="passwordComplexityRegEx" onChange={e => setFormInput(e)} value={passwordComplexityRegEx} />
                                    </div>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Password Complexity Note</label>
                                        <input type="text" className="form-control" id="passwordComplexityNote" name="passwordComplexityNote" onChange={e => setFormInput(e)} value={passwordComplexityNote} />
                                    </div>
                                </div>
                            </div>

                            <div className="row" style={{ marginTop: "-10px" }}>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Requestor Name</label>
                                        <input type="text" className="form-control" id="requestorName" name="requestorName" onChange={e => setFormInput(e)} value={requestorName} />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Requestor Email</label>
                                        <input type="text" className="form-control" id="requestorEmail" name="requestorEmail" onChange={e => setFormInput(e)} value={requestorEmail} />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Requestor Description</label>
                                        <textarea name="textarea" cols="30" rows="3" className="form-control" id="requestorDescription" name="requestorDescription" onChange={e => setFormInput(e)} value={requestorDescription} ></textarea>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <span style={{ marginLeft: "15px" }}>Created at : {company.dateCreated} / Modified at: {company.dateModified}</span>
                            </div>
                        </div>
                    </div>
                </div >
                <div className="card-footer text-muted">
                    <div style={{ textAlign: "center" }}>
                        <Popup trigger={<button className="btn btn-secondary" style={{ marginRight: "5px" }}>Save</button>} nested modal>{close => (<Confirmation hideAction="false" title="Save Company" message="Are you sure, you want to save this company information?" buttonCaption="Save" onSuccess={onSuccess} onClose={() => { close(); }}></Confirmation>)}</Popup>
                        <button className="btn btn-secondary" onClick={params.onClose}>Close</button>
                    </div>
                </div>
            </div >
        </>
    );
};

export default NewCompany;